var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Calendar-Icon",
    d: "M6.75,3V5.25M17.25,3V5.25M3,18.75V7.5A2.25,2.25,0,0,1,5.25,5.25h13.5A2.25,2.25,0,0,1,21,7.5V18.75m-18,0A2.25,2.25,0,0,0,5.25,21h13.5A2.25,2.25,0,0,0,21,18.75m-18,0v-7.5A2.25,2.25,0,0,1,5.25,9h13.5A2.25,2.25,0,0,1,21,11.25v7.5m-9-6h.008v.008H12ZM12,15h.008v.008H12Zm0,2.25h.008v.008H12ZM9.75,15h.008v.008H9.75Zm0,2.25h.008v.008H9.75ZM7.5,15h.008v.008H7.5Zm0,2.25h.008v.008H7.5Zm6.75-4.5h.008v.008H14.25Zm0,2.25h.008v.008H14.25Zm0,2.25h.008v.008H14.25Zm2.25-4.5h.008v.008H16.5Zm0,2.25h.008v.008H16.5Z",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#068453",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/Calendar-Icon.628f255515cf1cf0372f4cbff4facbac.svg";
export { ForwardRef as ReactComponent };